import Cell from './Cell'
import Row from './Row'
import Table, { TableProps } from './Table'

const TableComponent = {
  Cell,
  Row,
  Table,
}

export type { TableProps }
export default TableComponent
